import * as React from "react";
import type { SVGProps } from "react";

interface GoalProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Goal = ({ cancelled = false, ...props }: GoalProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0"
      />
      <g fill="#000">
        <path d="M14.477 11.479a1.44 1.44 0 0 1 1.462 1.427 1.46 1.46 0 0 1-1.456 1.47 1.48 1.48 0 0 1-1.454-1.453 1.446 1.446 0 0 1 1.448-1.444M6.586 11.686c-.763.003-1.363-.651-1.36-1.483.005-.83.614-1.498 1.362-1.494.73.003 1.335.666 1.353 1.48.017.807-.604 1.494-1.355 1.497M9.244 16.339c-.82-.003-1.427-.608-1.419-1.41a1.406 1.406 0 0 1 1.407-1.376c.793 0 1.44.637 1.436 1.413-.004.782-.62 1.376-1.424 1.373M19.805 11.05c.011.395-.127.763-.395 1.078-.38.446-.946.457-1.35.036-.574-.598-.562-1.804.023-2.392.407-.409.976-.38 1.352.078.277.338.387.737.37 1.2M12.044 6.075c.776.013 1.361.603 1.289 1.3-.073.69-.7 1.158-1.463 1.093-.683-.058-1.2-.602-1.177-1.238.023-.66.617-1.167 1.35-1.155M12.121 19.748c-.398-.138-.813-.22-1.162-.42-.486-.278-.462-.767.002-1.082.598-.408 1.722-.407 2.319 0 .492.336.505.838-.014 1.117-.34.182-.736.252-1.145.385M18.198 6.42c-.003.535-.318.819-.837.754-.81-.102-1.565-1.146-1.381-1.912.082-.345.307-.526.657-.53.75-.006 1.566.875 1.561 1.687M6.125 5.712c-.02.713-.787 1.748-1.464 1.975-.378.127-.655-.07-.638-.487.029-.709.414-1.237.908-1.693.136-.126.303-.227.472-.304.443-.202.736.01.722.509M4.483 15.74c-.001-.455.263-.637.683-.471.658.26 1.36 1.272 1.375 1.982.01.456-.25.646-.675.493-.653-.234-1.382-1.29-1.383-2.004M9.003 4.194c-.23-.049-.472-.065-.686-.153-.31-.128-.38-.434-.15-.682.172-.184.39-.344.616-.45.527-.248 1.088-.393 1.665-.226.185.053.434.216.47.372.035.157-.115.419-.26.545-.466.408-1.04.55-1.655.594M19.613 15.497c-.14.722-.512 1.426-1.296 1.829-.372.191-.644 0-.665-.417-.036-.694.662-1.8 1.299-2.058.422-.17.675.026.662.646M2.133 10.803c.09-.392.167-.791.282-1.18.029-.097.171-.209.272-.22.068-.007.19.137.226.236.266.756.253 1.51-.065 2.25-.037.085-.159.199-.229.19-.093-.01-.225-.113-.25-.202-.096-.342-.156-.694-.236-1.074M20.44 9.49c.018-.168.02-.341.062-.504.024-.096.109-.177.166-.264.084.06.19.102.245.181a1 1 0 0 1 .172.378c.094.519.179 1.04.244 1.563a1 1 0 0 1-.075.44c-.078.212-.22.235-.34.046a2 2 0 0 1-.274-.594c-.097-.407-.153-.824-.226-1.237zM7.638 20.15c.759.101 1.39.294 1.943.687.116.082.178.241.264.365-.141.046-.285.138-.423.13-.676-.035-1.297-.265-1.86-.64-.124-.082-.192-.252-.286-.381zM14.856 3.06c-.646-.034-1.278-.134-1.839-.49-.088-.056-.133-.18-.198-.272.092-.051.18-.137.275-.146.733-.067 1.44.04 2.092.402.122.068.198.221.295.335-.14.057-.276.121-.419.167-.063.02-.137.003-.206.003M14.613 21.162l-.258-.118c.048-.092.074-.211.147-.27.565-.453 1.218-.696 1.929-.775.1-.011.209.068.314.105-.053.09-.087.206-.163.267-.565.455-1.227.672-1.969.791" />
      </g>
      <path
        fill="#000"
        d="M12 1.013C5.932 1.013 1.013 5.933 1.013 12S5.933 22.987 12 22.987 22.987 18.067 22.987 12 18.067 1.013 12 1.013M12 2.4a9.6 9.6 0 1 1 0 19.2 9.6 9.6 0 0 1 0-19.2"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Goal;
